/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { useAppSelector } from "../../../../infra/hooks";
import DTOReturnedAssets from "./DTOReturnedAssets";
import ReturnedAssetsPresenter from "./ReturnedAssetsPresenter";
import { useTranslation } from "react-i18next";

function ReturnedAssetsController() {
  const [allreturnassetData, setAllreturnassetData] = useState([]);
  const { t } = useTranslation();

  const isLoading = useAppSelector(
    (state) => state.returnAssetSlice.returnAssetsLoader
  );
  function callBackFunc(data: any) {
    setAllreturnassetData(data);
  }
  return (
    <>
      <DTOReturnedAssets setreturnassetData={callBackFunc} />
      <ReturnedAssetsPresenter
        returnedassetData={allreturnassetData}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}
export default ReturnedAssetsController;
